export default "__VITE_PUBLIC_ASSET__b7e0e0b3__"